(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Item', Item);

    Item.$inject = ['$resource', 'DateUtils'];

    function Item ($resource, DateUtils) {
        var resourceUrl =  'api/items/:id';

        return $resource(resourceUrl, {}, {
			'queryByTicket': {
                url: 'api/items/tickets/:id',
                method: 'GET',
                isArray: true
            },            

            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
